/**
 * ARVEXIS LOGO - BACKWARDS COMPATIBILITY LAYER
 * =============================================
 * 
 * Re-exports from the canonical ArvexisSymbol.jsx
 * All brand components now live in ArvexisSymbol.jsx per Brand Doctrine v1.0
 * 
 * This file exists for backwards compatibility with existing imports.
 */

import { 
  ArvexisSymbol,
  ArvexisLockup,
  ArvexisAvatar,
  ArvexisWordmark,
  ArvexisSymbolBreathing,
  ArvexisLockupBreathing,
  SYMBOL_SIZES,
  LOCKUP_SIZES
} from './ArvexisSymbol';

// Default export is the Symbol (for compact contexts)
const ArvexisLogo = ArvexisSymbol;

// Legacy export names pointing to new implementations
export const ArvexisLogoFull = ({ logoSize = 52, className = '' }) => (
  <ArvexisLockup width={logoSize * 3.5} className={className} />
);

export const ArvexisLogoBreathing = ({ size = 80, className = '' }) => (
  <ArvexisSymbolBreathing size={size} className={className} />
);

// Re-export all brand components
export { 
  ArvexisSymbol,
  ArvexisLockup,
  ArvexisAvatar,
  ArvexisWordmark,
  ArvexisSymbolBreathing,
  ArvexisLockupBreathing,
  LOCKUP_SIZES
};

// Size constants
export const LOGO_SIZES = SYMBOL_SIZES;

export default ArvexisLogo;
